import { SurveyMeta } from '@surveycake/logic-engine';

/*
 * 找 navigator.language 有沒有在 language_others 裡面
 * 有的話，回傳對應的 language_others
 */
const findNavigatorLanguageFromLanguageOthers = (meta: SurveyMeta) => {
  const language_others = meta.language && meta.language.language_others;
  return (
    language_others &&
    language_others.find(langOther =>
      langOther.toLowerCase().startsWith(navigator.language.toLowerCase())
    )
  );
};

export default findNavigatorLanguageFromLanguageOthers;
